﻿// <auto-generated/>
// this class has been generated with PowerShell
// see ./solution/Sbb.Meetings.Core/pre-build.ps1
/* eslint-disable */

import { TranslationLabels } from "./TranslationLabels";
export const englishLabels: TranslationLabels = {
  Actions: "Actions",
  Actions_Add: "Add",
  Actions_Add_Board: "Add",
  Actions_AddBoard: "Create",
  Actions_AddMeeting: "Add",
  Actions_AddMeeting_Submitting: "Adding meeting …",
  Actions_Back: "Back",
  Actions_Browse: "Browse …",
  Actions_Cancel: "Cancel",
  Actions_Close: "Close",
  Actions_Close_AriaLabel: "Close",
  Actions_Copy_AgendaItem: "Copy",
  Actions_Delete: "Delete",
  Actions_Delete_AgendaItem: "Delete",
  Actions_Delete_AgendaItem_Confirm: "Do you really want to delete this agenda item?",
  Actions_Delete_AgendaItem_Pending: "Agenda item is being deleted …",
  Actions_Delete_Document: "Delete document",
  Actions_Delete_Document_Confirm: "Do you really want to delete this document?",
  Actions_Delete_Document_Pending: "Document is being deleted …",
  Actions_Delete_Meeting: "Delete",
  Actions_Delete_Meeting_Confirm: "Do you really want to delete this meeting, including all agenda items, participants and pending items?",
  Actions_Delete_Meeting_Pending: "The meeting including all agenda, participants and tasks is being deleted …",
  Actions_Delete_Participant: "Delete",
  Actions_Delete_Participant_Confirm: "Do you really want to delete this participant?",
  Actions_Delete_Participant_Pending: "Participant is being deleted …",
  Actions_Delete_Task_Confirm: "Do you really want to delete this task?",
  Actions_Delete_Task_Pending: "Task is being deleted …",
  Actions_Delete_Task_Title: "Delete task",
  Actions_DocumentsGrid_Tooltip: "Action for synchronization",
  Actions_Download: "Download",
  Actions_Edit: "Edit",
  Actions_Edit_AgendaItem: "Edit agenda item",
  Actions_Edit_Meeting: "Edit meeting",
  Actions_Edit_Participant: "Edit participant",
  Actions_Edit_Task: "Edit task",
  Actions_EditSettings: "Edit settings",
  Actions_GoToBoard: "Open committee settings",
  Actions_GoToMeetings: "Open committee meetings",
  Actions_Help: "Help",
  Actions_HideChildren: "Hide subordinate elements",
  Actions_HideDiff: "Hide differences",
  Actions_Indent_AgendaItem: "Increase indentation",
  Actions_Move_AgendaItem: "Move",
  Actions_No: "No",
  Actions_None: "None",
  Actions_OneDriveMeetingFolder: "Open the meeting folder on OneDrive (available only after sync).",
  Actions_OneDriveSync: "Synchronize",
  Actions_OneDriveSync_Delete: "Delete",
  Actions_OneDriveSync_Failure: "The synchronization with OneDrive could not be performed, please try again.",
  Actions_OneDriveSync_Success: "Synchronization with OneDrive has been successfully completed.",
  Actions_OneDriveSyncFolder: "Open folder",
  Actions_Open: "Open",
  Actions_OpenPhonebook: "Open phone book",
  Actions_OpenUserProfile: "Open user profile",
  Actions_Outdent_AgendaItem: "Decrease indentation",
  Actions_Overwrite: "Overwrite",
  Actions_Participant_Edit: "Edit participant",
  Actions_Refresh: "Refresh",
  Actions_Reset: "Reset",
  Actions_Retry: "Try again",
  Actions_Save: "Save",
  Actions_SendTo_AgendaItem: "Send to",
  Actions_ShowChildren: "Show subordinate elements",
  Actions_ShowDiff: "Show differences",
  Actions_Submit: "Save",
  Actions_Synchronize: "Synchronize",
  Actions_ToggleDetails: "Show/hide details",
  Actions_View: "Details",
  Actions_View_AgendaItems: "View agenda items",
  Actions_View_Documents: "View documents",
  Actions_View_History: "Version history",
  Actions_View_Meeting: "View meeting",
  Actions_View_OneDriveSync: "Open OneDrive Synchronisation",
  Actions_View_Participants: "View participants",
  Actions_View_Tasks: "View tasks",
  Actions_Yes: "Yes",
  AddAgendaItemPosition: "Insert at",
  AddAgendaItemPosition_AfterSelected: "After the selected",
  AddAgendaItemPosition_ContextHelp: "Select where you want the new agenda item to be inserted. «At the end» will appear at the end of the meeting. «After the selected» will be placed directly after the agenda item currently selected. If no agenda item is selected, it will also be inserted at the end.",
  AddAgendaItemPosition_Last: "At the end",
  AddBoard_Label: "Add board",
  AddBoardPanel_Header: "Add board",
  Added: "Added",
  AddGroupMember: "Add member",
  AddMeeting_Description: "Enter the desired start date and time. When the meeting is created, the standard agenda items and standard participants are added according to the stored configuration. This could take a moment.",
  AddMeeting_Title: "Add meeting",
  AddParticipant_Description: "All authorized persons of the board can be added as participants to meetings.",
  AddParticipant_NoDataTemplate: "Participant not found. Additional participants can be added in the board settings.",
  AddParticipant_Placeholder: "Add participant …",
  AddParticipant_Title: "Add participant",
  AddUser: "Add",
  AddUser_Label: "Add user",
  Admin: "Admin",
  AdminBoardsFilter_Placeholder: "Search for boards …",
  AdminUsersFilter_Placeholder: "Search for users …",
  AgendaItem: "Agenda item",
  AgendaItem_Add_Submitting: "Adding agenda item …",
  AgendaItem_AdditionalInfo_Description: "-",
  AgendaItem_AdditionalInfo_Title: "Additional Info",
  AgendaItem_Confidential_Active_Tooltip: "The agenda item is strictly confidential. Working documents are managed outside the meeting administration and the minutes (strictly confidential) are distributed separately.",
  AgendaItem_Confidential_Description: "Please note here if the agenda item is strictly confidential. In this case, the document must be submitted by e-mail and the minutes must be kept in a separate, strictly confidential record.",
  AgendaItem_Confidential_Inactive_Tooltip: "The agenda item is confidential.",
  AgendaItem_Confidential_Title: "In strict confidence",
  AgendaItem_Confidential_Tooltip: "In strict confidence",
  AgendaItem_Decision_Description: "Please indicate here the concrete proposal for the resolution (to be transferred from the template).",
  AgendaItem_Decision_Title: "Decision",
  AgendaItem_Department_Description: "Please enter the abbreviation of the person responsible for the agenda item.",
  AgendaItem_Department_Title: "Responsible unit (abbreviation)",
  AgendaItem_Department_Tooltip: "Responsible unit",
  AgendaItem_DocumentStatus_Description: "Shows the number of documents associated with the agenda item",
  AgendaItem_DocumentStatus_Title: "Working documents",
  AgendaItem_DocumentStatus_Tooltip: "Documents",
  AgendaItem_Duration_Description: "Please indicate here the planned duration of the agenda item in minutes. Always give as little time as agreed/urgent.",
  AgendaItem_Duration_Title: "Duration [min.]",
  AgendaItem_Duration_Tooltip: "Duration",
  AgendaItem_EdecideType_Description: "The eDecide template type is used to create an eDecide run. The default value is empty. Only agenda items that contain a template type != empty are transmitted to eDecide.",
  AgendaItem_EdecideType_Title: "eDecide topic type",
  AgendaItem_EdecideType_Tooltip: "eDecide topic type",
  AgendaItem_Edit: "Edit",
  AgendaItem_EndTime_Description: "The field is automatically calculated based on the start time of the meeting and the duration of the agenda items.",
  AgendaItem_EndTime_Title: "End time",
  AgendaItem_FinalBoard_Description: "Please indicate in this field the final body (abbreviation) with the template type (BV, IV, Other). Example: KL-BV, VR-IV, GLP workshop.",
  AgendaItem_FinalBoard_Title: "Final Board / Template type",
  AgendaItem_FinalBoard_Tooltip: "Final Board / Template type",
  AgendaItem_FinalBoardDate_Title: "Final Board Date",
  AgendaItem_Guests_Description: "Please enter the guests for the agenda item here. Multiple values can be separated with semicolon <code>;</code> or a new line.",
  AgendaItem_Guests_Title: "Guests",
  AgendaItem_HeadingNumber_Description: "-",
  AgendaItem_HeadingNumber_Title: "No.",
  AgendaItem_Level_Description: "Internal field, not displayed",
  AgendaItem_Level_Title: "Level",
  AgendaItem_Locked_Active_Tooltip: "The agenda item is blocked for processing by members.",
  AgendaItem_Locked_Description: "Please lock the agenda item here if no one other than the owners of the body is to adjust anything.",
  AgendaItem_Locked_Inactive_Tooltip: "The agenda item has been cleared for editing by members.",
  AgendaItem_Locked_Title: "Locked",
  AgendaItem_Locked_Tooltip: "Locked for editing by members",
  AgendaItem_Meeting_ContextHelp_Title: "Meeting",
  AgendaItem_NavBar_AddAgendaItem: "Add",
  AgendaItem_NavBar_MeetingIsTemplate: "The meeting is a standard meeting (aka template) and is locked for editing by members.",
  AgendaItem_NavBar_MeetingLocked: "The meeting is locked for editing by members.",
  AgendaItem_NavBar_SubmittedAgendaItems: "Submitted agenda items",
  AgendaItem_NavBar_ToggleNav: "Show/hide navigation",
  AgendaItem_NavBar_ToggleView: "Select views",
  AgendaItem_NavBar_View: "View",
  AgendaItem_New_Placeholder: "New agenda item …",
  AgendaItem_Note_Description: "Please enter additional information on the agenda item here.",
  AgendaItem_Note_Title: "Remarks",
  AgendaItem_Perusal_Description: "Please indicate here the concrete proposal for taking note (to be transferred from the template).",
  AgendaItem_Perusal_Title: "Perusal",
  AgendaItem_Position_Description: "Internal field, not displayed",
  AgendaItem_Position_Title: "Position",
  AgendaItem_ProtocolEntry_Description: "Antragstext aus der Wordvorlage, mit welcher Bereiche Traktanden in die Sitzung einreichen. ev. = Beschluss. Erfassung geschieht durch Bereiche",
  AgendaItem_ProtocolEntry_Title: "Minutes Entry",
  AgendaItem_ProtocolEntryDraft_Description: "Log entry which is not displayed on the iPad.",
  AgendaItem_ProtocolEntryDraft_Title: "Minutes Entry (Draft)",
  AgendaItem_Sortable: "-",
  AgendaItem_Sortable_Tooltip: "The agenda items can be sorted using drag & drop.",
  AgendaItem_Speakers_Title: "Guests (Protocol)",
  AgendaItem_StandardVersion_Title: "Standard version",
  AgendaItem_StartTime: "-",
  AgendaItem_StartTime_Title: "Start time",
  AgendaItem_StartTime_Tooltip: "Start time",
  AgendaItem_Status: "Status",
  AgendaItem_Status_Description: "Status of the agenda item. Purely informative.",
  AgendaItem_Status_Title: "Status",
  AgendaItem_Title_Description: "Internal field - Calculated from Description and shortened to 255 characters maximum",
  AgendaItem_Title_Title: "Title",
  AgendaItem_Type_Description: "Please enter type.",
  AgendaItem_Type_Title: "Template type",
  AgendaItems: "Agenda items",
  AgendaItems_Description: "Contains the agenda items of the committee",
  AgendaItems_Loading: "Loading agenda items …",
  AgendaItems_Loading_EditForm: "Loading agenda item form …",
  AgendaItems_Title: "Agenda items",
  AgendaItemsDetail_Empty: "Please select an agenda item",
  AgendaItemsList_Empty: "No agenda items have been entered",
  AgendaItemStatus_Approved: "Approved",
  AgendaItemStatus_Archived: "Arhived",
  AgendaItemStatus_Default: "Draft",
  AgendaItemStatus_Deleted: "Deleted",
  AgendaItemStatus_Finalized: "Finalized",
  AgendaItemStatus_Itemized: "Itemized",
  AgendaItemStatus_Published: "Published",
  AgendaItemStatus_Unknown: "Unknown",
  AgendaItemType_Break: "Pause",
  AgendaItemType_Category: "Category",
  AgendaItemType_Decision: "BV",
  AgendaItemType_Decision_eDecide: "BV - eDecide",
  AgendaItemType_Decision_Tooltip: "Decision",
  AgendaItemType_Discussion: "Discussion",
  AgendaItemType_Empty: "Empty",
  AgendaItemType_Information: "IV",
  AgendaItemType_Information_eDecide: "IV - eDecide",
  AgendaItemType_Information_Tooltip: "Information",
  AgendaItemType_NoDataTemplate: "No type found",
  AgendaItemType_Other: "Other",
  AgendaItemType_Placeholder: "Choose type …",
  All: "All",
  ApplicationName: "SiVe",
  AuditLog: "Audit log",
  AuditLog_Action: "Action",
  AuditLog_Add: "Added",
  AuditLog_After: "After",
  AuditLog_Before: "Before",
  AuditLog_Changes: "Changes",
  AuditLog_Created: "Date",
  AuditLog_CreatedBy: "User",
  AuditLog_Date: "On",
  AuditLog_Diff: "Differences",
  AuditLog_Id: "Id",
  AuditLog_Properties: "Fields",
  AuditLog_Property: "Field",
  AuditLog_Remove: "Deleted",
  AuditLog_State: "Action",
  AuditLog_Update: "Updated",
  AuditLog_User: "By",
  AuditLogs: "Audit logs",
  Auth_Loading: "Loading application …",
  Auth_LoginFailed: "Login failed.",
  Auth_Redirecting: "Loading login …",
  Auth_TryAgain: "Try again.",
  Back: "Back",
  BackHome: "Back to the home page",
  BaseData: "Base Data",
  BlobDocument: "Document",
  Board: "Board",
  Board_ArchivedDate: "Archived date",
  Board_BoardUniqueId: "eDecide Board Id",
  Board_BoardUniqueId_Help: "The eDecide Panel Id is used to send runs from the current board to eDecide. This ID can be copied in eDecide in the screen Manage committee. The Send to function is only active if an Id has been entered here.",
  Board_BusinessOwner: "Person in charge",
  Board_BusinessOwner_Help: "The person who is formally responsible for this committee either originally set it up or took it over from a previous person in charge.",
  Board_ClearCache: "Clear cache of the board",
  Board_DefaultDuration: "Standard duration",
  Board_DefaultDuration_Help: "The standard duration is added to the start time for each newly created session and results in the planned end time.",
  Board_DefaultLocation: "Location",
  Board_DefaultLocation_Help: "This text is entered as the location/meeting room for each newly created meeting.",
  Board_DefaultRemarks: "Notes",
  Board_DefaultRemarks_Help: "This text is entered as a remark for each newly created meeting.",
  Board_DefaultTime: "Start time hh:mm",
  Board_DefaultTime_Help: "The time is used as the suggested start time for each newly created meeting.",
  Board_Description: "Description",
  Board_Description_Help: "-",
  Board_DownloadConfig: "Download configuration",
  Board_DownloadConfig_Tooltip: "Download the configuration list as a zip file",
  Board_DownloadUsers: "Download users",
  Board_DownloadUsers_Tooltip: "Download the user list as a CSV file",
  Board_EdecideId: "eDecide Board Id",
  Board_EdecideId_Help: "The eDecide Board Id is used to send runs from the current board to eDecide. This ID can be copied in eDecide in the screen Manage committee. The Send to function is only active if an Id has been entered here.",
  Board_Id: "Id",
  Board_Id_Help: "The database key of the committee",
  Board_LongName: "Long name",
  Board_LongName_Help: "The long name is used in the document templates and in the user interface of the meeting administration. Common values are the full name of a board such as Board of Directors or Executive Board.",
  Board_Name: "Internal name",
  Board_Name_Help: "The internal name is used as the unique name of the board in the browser address bar (URL). When an internal name is changed, the previous internal names remain mapped to the board and are preserved in the system.",
  Board_NameHistories_Title: "Previous names",
  Board_OrganisationUnit: "Organisation unit",
  Board_OrganisationUnit_Help: "The organisational unit with technical responsibility for this board usually corresponds to the person in charge.",
  Board_Settings: "Board settings",
  Board_ShortName: "Short name",
  Board_ShortName_Help: "The board short name is used in the document templates and in the user interface of the meetings administration. Usual values are an abbreviation of a body such as VR (Board of Directors), KL (Group Executive Board)",
  Board_SignatureFirstName: "Signature First name",
  Board_SignatureFirstName_Help: "The signature first name can be inserted when generating the e-mails, minutes and invitations.",
  Board_SignatureLastName: "Signature Surname",
  Board_SignatureLastName_Help: "The signature surname can be inserted when generating the e-mails, minutes and invitations.",
  Board_Status: "Status",
  Board_Status_Help: "The status of the board reflects the life cycle in SiVe. Deleted boards are no longer displayed in the dashboard.",
  Board_Update_Error: "Board could not be saved: {0}",
  Board_Update_Success: "Board has been saved",
  BoardMemberships: "Permissions",
  BoardPicker_Placeholder: "Enter committee identifier …",
  Boards: "Boards",
  BoardSettings: "Board settings",
  BoardSettings_MeetingDefaults: "Default values for the meetings",
  BoardSettings_StandardMeetingOldOnly: "The following settings are only used when the standard meeting «{0}» is applied.",
  BoardStatus_Active: "Active",
  BoardStatus_Archived: "Archived",
  BoardStatus_Deleted: "Deleted",
  BoardStatus_Draft: "Draft",
  BoardStatus_Unknown: "Unknown",
  BoardTemplate_Delete_Error: "Template could not be deleted: {0}",
  BoardTemplate_Delete_Success: "Template was deleted",
  BoardTemplate_Upload_Error: "Template could not be uploaded: {0}",
  BoardTemplate_Upload_Success: "Template was uploaded successfully",
  BoardTemplate_UploadTitle: "Upload template",
  BoardTemplates_Description: "These templates have been adapted for the current board. Contact egpl@sbb.ch if you need help with the configuration.",
  BoardTemplates_Title: "Committee templates",
  BoardUnique: "Unique id",
  BusinessOwner: "Business owner",
  ButtonHelp: "Help",
  By: "by",
  ClaimIssuer: "Claim issuer",
  Claims: "User claims",
  ClaimType: "Claim type",
  Confirm_Accept: "YES",
  Confirm_Cancel: "Cancel",
  Confirm_Content: "Unsaved changes detected. Do you really want to discard the changes?",
  Confirm_Discard: "Discard changes",
  Confirm_Title: "Unsaved changes",
  ContextHelp: "Help",
  ContextHelp_Fallback_Content: "There is no context help for the topic {0}.",
  ContextHelp_Fallback_Title: "Help",
  ContextHelp_TemplateId_Description: "The attributes of the selected standard meeting (meeting, agenda, participants) are adopted when the new meeting is created. If you select empty, only the meeting is created, so agenda items and participants can be applied later.",
  ContextHelp_TemplateId_Title: "Select standard meeting",
  CopyToClipboard: "Copy to clipboard",
  CopyToClipboard_Idle: "Copy to clipboard…",
  CopyToClipboard_Success: "Copied!",
  Created: "Created",
  Dashboard_Button_OwnerExport: "Download complete list",
  Dashboard_Button_UserExport: "Export to Excel",
  Dashboard_EmptyTable: "No meetings were found that match your criteria.",
  Dashboard_Filter_Tasks: "Only my tasks",
  Dashboard_Grid_Header_EndDate: "Submission date",
  Dashboard_Grid_Header_Meeting: "Meeting",
  Dashboard_Grid_Header_StartDate: "Start date",
  Dashboard_Loading: "Loading meetings …",
  Dashboard_Meeting_PlannedEndTime: "Planned end time",
  Dashboard_Meeting_ProjectedEndTime: "Projected end time",
  Dashboard_Meeting_Tooltip: "Number of sessions from the selected date",
  Dashboard_Navbar_DetailedDashboard: "Open Detail-Dashboard",
  Dashboard_Navbar_Edecide: "eDecide öffnen",
  Dashboard_Toggle_MyCommittees: "My boards",
  Dashboard_Toggle_Tasks: "Show tasks",
  Date_Unknown: "Unknown",
  DateFilterBar_Dashboard_Description: "The dashboard shows the upcoming meetings of all the committees you are eligible to sit on. The date filter can be used to change the display period (default setting from today -14 days). All displayed committees and meetings can be accessed by clicking on them.",
  DateFilterBar_Dashboard_Title: "Date filter",
  DateFilterBar_Meetings_Description: "The date filter can be used to change the display period (default setting: today -14 days).",
  DateFilterBar_Meetings_Title: "Date filter",
  DateFilterBar_ShowMeetings: "Show meetings from",
  DefaultDuration: "Duration",
  DefaultLocation: "Location",
  DefaultRemarks: "Notes",
  DefaultTemplates_Description: "The standard configuration of the application is installed with the application by the SiVe development team. Corrections to templates are thus automatically updated for all boards.",
  DefaultTemplates_Title: "Templates",
  DefaultTime: "Start time",
  Deleted: "Deleted",
  DeputyMember: "Deputy members",
  DeputyVisitor: "Deputy visitors",
  Description: "Description",
  DismissableDialog_Close_Label: "Close",
  DismissableDialog_Close_Tooltip: "Do not display message again",
  Document_Action_Title: "Action",
  Document_Add_Uploading: "Document is being uploaded …",
  Document_Confidential_Title: "In strict confidence",
  Document_FileSize_Title: "Size",
  Document_Modified_Title: "Updated",
  Document_Modified_Tooltip: "Date of modification of the agenda item or file",
  Document_Title_Title: "Title",
  Document_Title_Tooltip: "Name of the agenda item or file",
  Documents_Loading: "Loading documents …",
  Documents_NavBar_Refresh: "Refresh",
  Documents_NavBar_Sync_Description: "Select an action in the Action column for agenda items or individual documents and perform it using the Synchronize button",
  Documents_NavBar_Sync_Submitting: "Synchronizing files …",
  Documents_NavBar_Sync_Title: "Help on Synchronization",
  Documents_NavBar_ToggleNav: "Show/hide navigation",
  Documents_NavBar_View: "View",
  Documents_Refreshing: "Refreshing documents …",
  Documents_Secret: "Additional documents",
  DocumentsForm_None: "None",
  DocumentsList_Empty: "No agenda items have been entered.",
  DocumentsPanel_Description: "The following files have been uploaded for this agenda item",
  DocumentsPanel_Header: "Documents",
  DocumentsPanel_Loading: "Loading documents …",
  DocumentStatus_Default: "Active",
  DocumentStatus_Deleted: "Deleted",
  Edecide: "eDecide",
  Edecide_NoBoardLinked: "Committe is not linked to an eDecide board.",
  Edecide_RunManagementUrl: "Edit run",
  Edecide_RunUrl: "Run details",
  EdecidePanel_CreateRun_Failure: "Run could not be created.",
  EdecidePanel_CreateRun_Failure_NotFound: "The eDecide Board does not exist. Please check the eDecide Board Id in the settings.",
  EdecidePanel_CreateRun_Success: "Run created",
  EdecidePanel_DuplicateRuns: "Existing run found",
  EdecidePanel_DuplicateRuns_Text: "At least one eDecide run exists with this external ID. If the data is to be transmitted again from Sive, the duplicates would have to be deleted first.",
  EdecidePanel_Header: "eDecide run",
  EdecidePanel_Loading: "Loading preview …",
  EdecidePanel_OverrideTitle: "Title",
  EdecidePanel_OverrideTitle_HelpContent: "The title of the run to be created in eDecide can be overridden in this field. This should only be necessary in exceptional cases. Checking duplicates is not done via the title, but via the external ID.",
  EdecidePanel_OverrideTitle_HelpTitle: "Override run title",
  EdecidePanel_Participant_Name: "Name",
  EdecidePanel_Participants: "Participants",
  EdecidePanel_Submit: "Create run",
  EdecidePanel_Submitting: "Creating the run in eDecide …",
  EdecidePanel_Topic_Title: "Title",
  EdecidePanel_Topic_Type: "Type",
  EdecidePanel_Topics: "Agenda items (topics)",
  EdecidePanel_UniqueId: "External id",
  EdecideStatus_CompleteRunFailure: "Run could not be completed.",
  EdecideStatus_CompleteRunSuccess: "Run completed successfully.",
  EdecideStatus_CompletingRun: "Run is being completed …",
  EdecideStatus_CreateRunFailure: "Run could not be created.",
  EdecideStatus_CreateRunSuccess: "The run has been created successfully",
  EdecideStatus_CreatingRun: "Run is being created …",
  EdecideStatus_Empty: "No run has been started.",
  EdecideType_Decision: "Decision",
  EdecideType_Decision_Tooltip: "This agenda item is transmitted to eDecide as a decision topic",
  EdecideType_Default: "-",
  EdecideType_Information: "Information",
  EdecideType_Information_Tooltip: "This agenda item will be sent to eDecide as an information topic",
  EditAgendaItemPanel_Header: "Edit agenda item",
  EditBoardPanel_Header: "Edit board",
  EditMeetingPanel_Header: "Edit meeting",
  EditParticipantPanel_Header: "Edit participant",
  EditTaskPanel_Header: "Edit task",
  Email: "Email",
  EmptyTable: "No data available in table",
  Entity: "Entity",
  Entity_Add_Failure: "{EntityName} could not be created.",
  Entity_Add_Success: "{EntityName} was created successfully.",
  Entity_Delete_ConfirmContent: "Do you really want to delete {EntityName}?",
  Entity_Delete_ConfirmTitle: "Confirm deletion",
  Entity_Delete_Failure: "{EntityName} could not be deleted.",
  Entity_Delete_Success: "{EntityName} deleted successfully.",
  Entity_IsDeleted_Description: "This record has been deleted (Status: Deleted). The record can usually be reactivated by setting a different status than deleted.",
  Entity_IsDeleted_Title: "Is deleted",
  Entity_Patch_Failure: "Your request could not be processed, please try again.",
  Entity_Patch_SuccessNoChanges: "Your request has been processed, but no changes have been detected.",
  Entity_Patch_Unauthorized: "You are not authorised to make this adjustment.",
  Entity_Refresh_Failure: "{EntityName} could not be reloaded.",
  Entity_Refresh_Success: "{EntityName} reloaded successfully.",
  Entity_Save_Failure: "{EntityName} could not be saved.",
  Entity_Save_Success: "{EntityName} saved successfully.",
  Entity_Update_Failure: "{EntityName} could not be updated.",
  Entity_Update_Success: "{EntityName} updated successfully.",
  EntityCount: "# Entries",
  EntityTitle_Unknown: "Unknown",
  Error_FailedToAddUser: "User '{0}' could not be added.",
  ErrorCodes_BadRequest: "Something failed in the query. This is a client error (for example: incorrect query syntax, invalid framing of the request message or misleading request routing).",
  ErrorCodes_InternalServerError: "An error occurred while processing your request.",
  ErrorCodes_NoResponse: "The backend service is not available.",
  ErrorCodes_NotFound: "The resource was not found.",
  ErrorCodes_Unauthorized: "You do not have permission to access the resource.",
  ErrorDialog_AppInsights: "The following properties can be used to analyse the error that has occurred on the App Insights in the Azure Portal (Investigate > Search > Filter). Please add these properties when creating the Incident.",
  ErrorDialog_AppInsights_Date: "Date",
  ErrorDialog_AppInsights_OperationId: "Operation",
  ErrorDialog_AppInsights_SessionId: "Meeting",
  ErrorDialog_AppInsights_UserId: "User",
  ErrorDialog_AuthFailure_Text: "An authentication error occurred while executing the request. Please reload the page and try again.",
  ErrorDialog_AuthFailure_Title: "Authentication error",
  ErrorDialog_ComponentFailure_Text: "An error has occurred in the user interface. Please check the error message in the browser console (F12)",
  ErrorDialog_ComponentFailure_Title: "UI Error",
  ErrorDialog_ForbiddenFailure_Text: "You do not have permission to perform this operation or access this resource.",
  ErrorDialog_ForbiddenFailure_Title: "Access denied",
  ErrorDialog_NotFoundFailure_Text: "The record was not found. It may have been deleted by another user in the meantime, or an invalid combination of parameters was used. Please try again.",
  ErrorDialog_NotFoundFailure_Title: "Not found",
  ErrorDialog_OneDrive_Text: "A general OneDrive error has occurred. Please contact IT Support.",
  ErrorDialog_OneDrive_Title: "OneDrive Error",
  ErrorDialog_OneDriveMissingSource_Title: "OneDrive Error",
  ErrorDialog_OneDriveNotFound_Text: "OneDrive has not been activated for your account. Please contact IT Support.",
  ErrorDialog_OneDriveNotFound_Title: "OneDrive Error",
  ErrorDialog_OneDrivePermissionsDenied_Text: "You are not a participant in this meeting, so OneDrive Sync is not available.",
  ErrorDialog_OneDrivePermissionsDenied_Title: "No permission for OneDrive Sync",
  ErrorDialog_ServerFailure_Text: "A server error occurred while executing the request. Please reload the page and try again.",
  ErrorDialog_ServerFailure_Title: "Server error",
  ErrorDialog_UnknownFailure_Text: "An unknown error occurred while executing the request. Please reload the page and try again.",
  ErrorDialog_UnknownFailure_Title: "Unknown Error",
  Exception: "Exception",
  Exists: "Exists",
  Extended_Mode: "Extended mode",
  File: "File",
  FileAction_Delete: "Will be deleted",
  FileAction_Existing: "Existing",
  FileAction_New: "Will be uploaded",
  FileAction_Overwrite: "Will be overwritten",
  FileCount_Tooltip: "Number of documents",
  FileName: "Filename",
  FileSize: "File size",
  Filter_Combobox_Filter_Customize: "Filter",
  Filter_Keywords_Description: "Search the table for keywords",
  FilterToggle_ShowAgendaItems: "Show agenda items",
  FilterToggle_ShowAgendaItems_Description: "Show agenda items of expanded boards and meetings.",
  FilterToggle_ShowAgendaItems_Title: "Show agenda items",
  FirstName: "Firstname",
  FolderName: "Folder",
  Footer_Help: "Help",
  Footer_HelpTitle: "SBB eDecide Help",
  Footer_Imprint: "Imprint",
  Footer_Support: "Support",
  Footer_Title: "Imprint and help",
  GeneratedDocuments_Description: "Contains the generated documents of a committee (output menu)",
  GeneratedDocuments_Title: "Generated Documents",
  GeneratorVariable_AgendaItem: "Agenda item",
  GeneratorVariable_NoAgendaItems: "No agenda items found",
  GeneratorVariable_Nr: "No.",
  GeneratorVariable_ParticipantWithRoleNotFound: "No participant with role '{0}' was found!",
  GeneratorVariable_SeeConfidentialProtocol: "See minutes (strictly confidential)",
  GeneratorVariable_When: "When",
  GeneratorVariable_Who: "Who",
  GridWorksConfig_Description: "Contains the configuration and templates of a board",
  GridWorksConfig_Title: "Configuration",
  Group: "Group",
  Group_Add: "Add group",
  Group_AddError: "Group could not be added",
  Group_AddSuccess: "Group was successfully added",
  Group_CleanupDeletedUsers: "The group contains {0} deleted users, please clean up these entries!",
  Group_ConfirmDelete: "Do you really want to remove the group?",
  Group_DeleteError: "Group could not be removed",
  Group_EntraIdName: "Name in Entra Id",
  Group_EntraIdName_Description: "If you link an Entra ID group (Omada) group here, the members are imported periodically. If no link is defined, the members can be deleted and added to the right.",
  Group_Id: "Id",
  Group_MemberCount: "# Members",
  Group_Members: "Members",
  Group_Name: "Name",
  Group_Search: "Search for group …",
  Group_SearchStringHint: "The name of the AD Group is supported.",
  Group_Titles: "AD Groups",
  GroupMember_ExistsInGroup: "Exists in group",
  Groups: "Groups",
  Header_English: "English",
  Header_French: "Français",
  Header_German: "Deutsch",
  Header_Help: "Help",
  Header_Italian: "Italiano",
  Header_SettingsMenu: "Settings",
  Header_SettingsMenu_Cache: "View cache",
  Header_SettingsMenu_EditBoard: "Edit settings",
  Header_SettingsMenu_ViewBoard: "View settings",
  Header_UserMenu: "Current User",
  Header_UserMenu_OneDrive: "OneDrive",
  Header_UserMenu_Profile: "My account",
  Header_UserMenu_SignOut: "Sign out",
  Header_Version: "Version",
  Help: "Help",
  HelpMenu_CosProductPage: "COS product eGPL 2",
  HelpMenu_Manuals: "Manuals",
  HelpMenu_Support: "Support",
  HelpMenu_VivaEngage: "Viva Engage group eGPL 2",
  History: "History",
  Home: "Home",
  Id: "Id",
  ImportedFromPhonebook: "Fields imported from phone book",
  Info: "Showing _START_ to _END_ of _TOTAL_ entries",
  InfoFiltered: "(filtered from _MAX_ total entries)",
  Initials: "Initials",
  Initials_HelpText: `If you leave the field empty, the default will be applied.<br/>
First letter of first name, first letter of surname.`,
  Initials_Preview: "Preview",
  KendoReactGrid_CalendarToday: "Today",
  KendoReactGrid_FilterAfterOperator: "Is after",
  KendoReactGrid_FilterAfterOrEqualOperator: "After or equals",
  KendoReactGrid_FilterBeforeOperator: "Is before",
  KendoReactGrid_FilterBeforeOrEqualOperator: "Is before or equal to",
  KendoReactGrid_FilterBooleanAll: "(All)",
  KendoReactGrid_FilterContainsOperator: "Contains",
  KendoReactGrid_FilterDoesNotContain: "Does not contain",
  KendoReactGrid_FilterEndWith: "Ends with",
  KendoReactGrid_FilterEqOperator: "Equals",
  KendoReactGrid_FilterGteOperator: "Is greater than or equal to",
  KendoReactGrid_FilterGtOperator: "Is greater than",
  KendoReactGrid_FilterIsEmpty: "Is empty",
  KendoReactGrid_FilterIsFalse: "Is false",
  KendoReactGrid_FilterIsNotEmpty: "Is not empty",
  KendoReactGrid_FilterIsNotEqualTo: "Is not equal to",
  KendoReactGrid_FilterIsNotNull: "Is not null",
  KendoReactGrid_FilterIsNull: "Is null",
  KendoReactGrid_FilterIsTrue: "Is true",
  KendoReactGrid_FilterLteOperator: "Is less than or equal to",
  KendoReactGrid_FilterLtOperator: "Is less than",
  KendoReactGrid_FilterStartsWith: "Starts with",
  KendoReactGrid_NoRecords: "No entries available.",
  KendoReactGrid_PagerInfo: "{0} - {1} of {2} elements",
  KeywordSearch: "Keyword search",
  Language: "Language",
  LastModified: "Last modified",
  LastModifiedBy: "Last modified by",
  LastName: "Lastname",
  LastSync: "Last synchronisation",
  Loading: "Loading …",
  Loading_MeetingTemplates: "Loading Standard meetings …",
  Logout: "Logout",
  LongName: "Long name",
  Meeting: "Meeting",
  Meeting_AdditionalInfo_Description: "Text or link to further information",
  Meeting_AdditionalInfo_Title: "Additional info",
  Meeting_AgendaItems_Warning_Tooltip: "The agenda for the standard meeting has been updated. The standard can be applied to this meeting with Update agenda items.",
  Meeting_Difference_Title: "Difference",
  Meeting_DocumentStatus_ContextHelp_Title: "Working documents",
  Meeting_DocumentStatus_Description: "Shows the number of documents associated with the meeting",
  Meeting_DocumentStatus_Title: "Working documents",
  Meeting_Duration_Title: "Duration",
  Meeting_EdecideStatus_Description: "-",
  Meeting_EdecideStatus_RunManagementUrl: "Link 'Edit run' in eDecide",
  Meeting_EdecideStatus_RunUrl: "Link 'Run details' in eDecide",
  Meeting_EdecideStatus_Status: "Status of the run in SiVe/eDecide",
  Meeting_EdecideStatus_Title: "eDecide Status",
  Meeting_EndDate_Description: "Please indicate the end date and time of the session. The end time corresponds to a plan size. This is compared with the effective end time. If the scheduled time is exceeded, a red traffic light appears in the utilization display, and if it is not reached, a green traffic light appears.",
  Meeting_EndDate_Title: "Planned end date",
  Meeting_EventDate: "Date",
  Meeting_EventDate_Description: "Please indicate the start date and time of the session. The start times of the agenda items are then calculated automatically.",
  Meeting_EventDate_Title: "Date",
  Meeting_EventTime_Title: "Planned start time",
  Meeting_IssueDate_Description: "This field sets the submission date of the documents for the meeting.",
  Meeting_IssueDate_Title: "Issue date",
  Meeting_IsTemplate: "Is standard",
  Meeting_IsTemplate_Description: "Changes the current meeting to a default meeting so that it can be used as a template when creating new meetings. If the current meeting is a default meeting, it can be changed back to a regular meeting.",
  Meeting_IsTemplate_Title: "Is standard",
  Meeting_Loading: "Loading meeting …",
  Meeting_Loading_EditForm: "Loading meeting form …",
  Meeting_Location_Description: "Please indicate meeting place and room. Sequence: room name, floor, street no., postcode city",
  Meeting_Location_Title: "Location",
  Meeting_Locked_Active_Tooltip: "The meeting is closed to members to edit.",
  Meeting_Locked_Description: "Please lock the session here if necessary. When Locked, no one can enter an agenda item. Particularly suitable for reserve meetings or for business planning and management.",
  Meeting_Locked_Inactive_Tooltip: "The session is open for members to edit.",
  Meeting_Locked_Title: "Locked",
  Meeting_New_Placeholder: "New meeting …",
  Meeting_Note_Description: "Please identify important/overriding session notes here, for example Meeting takes place extra muros.",
  Meeting_Note_Title: "Remarks",
  Meeting_PlannedEndTime_Title: "Planned end time",
  Meeting_ProjectedEndTime: "Projected end time",
  Meeting_ProjectedEndTime_Description: "-",
  Meeting_ProjectedEndTime_Title: "Projected end time",
  Meeting_Status_Description: "Please record the status of the meeting in this field",
  Meeting_Status_Title: "Status",
  Meeting_SubmissionDate_Description: "Please indicate here the date of submission of the documents to be submitted.",
  Meeting_SubmissionDate_Title: "Submission date preliminary documents",
  Meeting_TemplateId_Title: "Standard meeting",
  Meeting_Title_Description: "Please use the following format: YYYY-MM-DD_BoardName-Sitzung (Example: 2019-08-12_KL-Sitzung).",
  Meeting_Title_Title: "Title",
  Meeting_UpdateParticipants_Warning_Tooltip: "The participants of the standard meeting have been updated. The standard can be applied to this meeting with Update participants.",
  Meeting_WorkingDocumentStatus_Title: "Working documents",
  Meeting_WorkingDocumentUrl_Description: "-",
  MeetingParticipants_Description: "Contains the participants of the meetings",
  Meetings: "Meetings",
  Meetings_Description: "Contains the meetings",
  Meetings_EmptyTable: "No meetings were found that match your criteria.",
  Meetings_Loading: "Loading meetings …",
  Meetings_Title: "Meetings",
  MeetingStatus_Archived: "Archived",
  MeetingStatus_Complete: "Closed",
  MeetingStatus_Default: "Draft",
  MeetingStatus_Deleted: "Deleted",
  MeetingStatus_Published: "Published",
  MeetingStatus_Unknown: "Unknown",
  Member: "Member",
  Modified: "Modified",
  ModifiedBy: "Modified by",
  More: "More",
  MoreEntries: "({0} entries)",
  MultiSelect_AllSelected: "Selected all",
  MultiSelect_FilterPlaceholder: "Filter …",
  MultiSelect_NoneSelected: "No Selection",
  MultiSelect_Reset: "Reset Selection",
  MultiSelect_SelectAll: "Select All",
  MultiSelect_Selected: "selected",
  MyRoles: "My roles",
  Name: "Name",
  Navigation_Administration: "Administration",
  No: "No",
  NoTitle: "No title",
  OneDrive_Sync_Mismatch: "Documents are available that have not yet been published for synchronization.",
  OneDriveDocument: "OneDrive Document",
  OneDriveSync_RemoteDocumentExistsUseOverwrite: "OneDrive file already exists for {0}, select \"Overwrite\" in the actions dropdown to replace it.",
  OneDriveSync_RemoteFileNotUploaded: "Document {0} could not be uploaded. Error: {1}",
  OneDriveSync_WorkingDocumentContentNotFound: "Working document {0} contents could not be loaded!",
  OneDriveSync_WorkingDocumentDoesNotExist: "Working document {0} does not exist!",
  OpenLinkNewWindow: "Open link (in new window)",
  OrganisationUnit: "Organisation unit",
  OriginalPath: "Request path",
  OutputDocument: "Output document",
  OutputDocument_AgendaItemConfirmedMail_Description: "Creates an Outlook template that can be used to notify a submitter that a submitted agenda item has been approved",
  OutputDocument_AgendaItemConfirmedMail_Title: "Confirm agenda item",
  OutputDocument_AgendaItemDeferredMail_Description: "Creates an Outlook template with which a submitting person can be informed that a submitted agenda item has been moved",
  OutputDocument_AgendaItemDeferredMail_Title: "Defer agenda item",
  OutputDocument_AgendaItemProtocolExtract_Description: "Creates the protocol extract in Word format",
  OutputDocument_AgendaItemProtocolExtract_Title: "Create protocol extract",
  OutputDocument_AgendaItemProtocolExtractMail_Description: "Creates an Outlook template for the selected agenda item, with the protocol extract attached as PDF",
  OutputDocument_AgendaItemProtocolExtractMail_Title: "Send protocol extract",
  OutputDocument_AgendaItemProtocolExtractPdf_Description: "Creates the protocol extract in PDF format",
  OutputDocument_AgendaItemProtocolExtractPdf_Title: "Create protocol extract",
  OutputDocument_ApplyStandardMeeting_Description: "Select a standard meeting and apply the attributes of the meeting, agenda items and participants to the existing meeting.",
  OutputDocument_ApplyStandardMeeting_Title: "Apply standard meeting",
  OutputDocument_Description: "Output document description",
  OutputDocument_Language: "Language",
  OutputDocument_Language_All: "All",
  OutputDocument_Language_None: "None",
  OutputDocument_MeetingAgendaItems_Description: "Creates an agenda overview in Excel format",
  OutputDocument_MeetingAgendaItems_Title: "Create agenda item overview",
  OutputDocument_MeetingClone_Description: "-",
  OutputDocument_MeetingClone_Title: "Copy meeting",
  OutputDocument_MeetingComplete_Description: "Closes the current meeting. From this point on, editing options are limited",
  OutputDocument_MeetingComplete_Title: "Complete meeting",
  OutputDocument_MeetingEdecide_Description: "Creates a run in eDecide",
  OutputDocument_MeetingEdecide_Title: "Create eDecide run",
  OutputDocument_MeetingFixate_Description: "Fixates the current meeting. From this point on, the chapter numbers for the invitation are fixed",
  OutputDocument_MeetingFixate_Title: "Fixates meeting",
  OutputDocument_MeetingInvitation_Description: "-",
  OutputDocument_MeetingInvitation_Title: "Create invitation",
  OutputDocument_MeetingInvitationMail_Description: "Creates the invitation as an Outlook template for sending to participants",
  OutputDocument_MeetingInvitationMail_Title: "Send invitiation",
  OutputDocument_MeetingOneNote_Description: "-",
  OutputDocument_MeetingOneNote_Title: "Create OneNote",
  OutputDocument_MeetingOverview_Description: "Creates the list of ageda items for the participants (invitation)",
  OutputDocument_MeetingOverview_Title: "Create agenda item list",
  OutputDocument_MeetingPresentationReminderMail_Description: "Creates an Outlook template that can be used to send a reminder to submit the presentation documents",
  OutputDocument_MeetingPresentationReminderMail_Title: "Send presentation reminder",
  OutputDocument_MeetingProtocolConfidential_Description: "Creates the protocol in Word format with the strictly confidential agenda items",
  OutputDocument_MeetingProtocolConfidential_Title: "Create protocol (strictly confidential)",
  OutputDocument_MeetingProtocolMail_Description: "Creates the protocol as a Outlook template",
  OutputDocument_MeetingProtocolMail_Title: "Send protocol",
  OutputDocument_MeetingProtocolNonConfidential_Description: "Creates the protocol as a Word template",
  OutputDocument_MeetingProtocolNonConfidential_Title: "Create protocol",
  OutputDocument_MeetingReminderMail_Description: "Creates an Outlook template that can be used to send a reminder to submit the documents",
  OutputDocument_MeetingReminderMail_Title: "Send Reminder",
  OutputDocument_MeetingSaveAsDefault_Description: "Overwrites the current standard meeting of this committee with the agenda items and participants applicable to this meeting.",
  OutputDocument_MeetingSaveAsDefault_Title: "Save as default",
  OutputDocument_MeetingUpdateAgendaItems_Confirm: "All agenda items, except those added manually, are deleted and the agenda list of the standard meeting is applied.",
  OutputDocument_MeetingUpdateAgendaItems_Confirm_Title: "Update agenda items?",
  OutputDocument_MeetingUpdateAgendaItems_Description: "All agenda items, except those added manually, are deleted and the agenda list of the standard meeting is applied.",
  OutputDocument_MeetingUpdateAgendaItems_Title: "Update agenda items",
  OutputDocument_MeetingUpdateParticipants_Confirm: "All participants, except those added manually, are deleted and the participant list of the default meeting is applied.",
  OutputDocument_MeetingUpdateParticipants_Confirm_Title: "Update participants?",
  OutputDocument_MeetingUpdateParticipants_Description: "All participants, except those added manually, are deleted and the participant list of the default meeting is applied.",
  OutputDocument_MeetingUpdateParticipants_Title: "Update participants",
  OutputDocument_Name: "Output document",
  OutputDocument_Task_Description: "View tasks",
  OutputDocument_Task_Title: "View tasks",
  OutputDocument_WorkingDocumentsExportFolders_Description: "Creates an archive with all working documents of the current meeting",
  OutputDocument_WorkingDocumentsExportFolders_Title: "Export working documents (zip)",
  OutputDocuments_Button_AgendaItem: "Current agenda item",
  OutputDocuments_Button_Meeting: "Current meeting",
  OutputDocuments_Empty: "No documents have been generated.",
  OutputDocuments_FolderUrl: "The following output documents have been successfully created",
  OutputDocuments_Header: "Output documents",
  OutputDocuments_Loading: "Creating output documents …",
  OutputDocuments_Success: "Saved successfully",
  OutputDocuments_Table_Name: "Document name",
  OutputDocuments_Table_Size: "Size",
  Owner: "Owner",
  Page_About_Title: "About SiVe",
  Page_Admin_Title: "Administration",
  Page_Administration_Title: "Administration",
  Page_AgendaItem_Title: "Agendaitem «{0}»",
  Page_AgendaItems_Title: "Agenda Items",
  Page_Board_Title: "Board «{0}»",
  Page_BoardCache_Title: "Cache of the board",
  Page_BoardEdit_Title: "Edit board «{0}»",
  Page_Boards_Title: "Boards",
  Page_BoardSetup_Title: "Board setup",
  Page_BoardTemplates_Title: "Board templates",
  Page_Cache_Title: "Cache",
  Page_Claims_Title: "User claims",
  Page_Dashboard_Description: "The dashboard shows the upcoming meetings of all the committees you are eligible to sit on. The date filter can be used to change the display period (default setting from today minus 10 days). All displayed committees and meetings can be accessed by clicking on them.",
  Page_Dashboard_Title: "Dashboard",
  Page_Default_Title: "Overview",
  Page_DetailedDashboard_Title: "Overview Meetings & Agenda items",
  Page_Document_Title: "Document",
  Page_Documents_Title: "Documents",
  Page_Error_SubTitle: "An error occurred while processing your request.",
  Page_Error_Title: "Error",
  Page_Group_Title: "Group «{0}»",
  Page_Groups_Title: "Groups",
  Page_Impersonate_Title: "Assume identity",
  Page_JobStatus_Title: "Job status",
  Page_Mails_Title: "Inxmail Testing",
  Page_Meeting_Title: "Meeting",
  Page_MeetingName_Title: "Meeting «{0}»",
  Page_Meetings_Title: "Meetings",
  Page_Memory_Title: "Memory",
  Page_OneDriveSync_Title: "OneDrive Synchronisation",
  Page_Participant_Title: "Participant «{0}»",
  Page_Participants_Title: "Participants",
  Page_Resources_Title: "Translations",
  Page_SendTo_Title: "Send to",
  Page_Settings_Title: "Settings",
  Page_Setup_Title: "Setup",
  Page_SignOut_Title: "Sign out",
  Page_StandardMeetingName_Title: "Standard meeting «{0}»",
  Page_StaticCache_Title: "Static cache",
  Page_Task_Title: "Task «{0}»",
  Page_Tasks_Title: "Tasks",
  Page_Translations_Title: "Translations",
  Page_User_Title: "User «{0}»",
  Page_UserEdit_Title: "Edit user «{0}»",
  Page_UserPreferences_Title: "Preferences",
  Page_Users_Title: "Users",
  Pagination_First: "First",
  Pagination_Last: "Last",
  Pagination_Next: "Next",
  Pagination_Previous: "Previous",
  Paging_First: "First",
  Paging_Items: "items",
  Paging_Last: "Last",
  Paging_Next: "Next",
  Paging_Of: "of",
  Paging_OutOfBounds: "The parameters (skip*take) exceed the number of available results.",
  Paging_Page: "Page",
  Paging_Previous: "Previous",
  Paging_SkipTooLarge: "The parameters (skip*take) exceed the number of available results.",
  Paging_TotalFiltered1: "1 item",
  Paging_TotalFilteredN: "{0} items",
  Paging_TotalUnfiltered: "(filtered from {0} total entries)",
  PagingFirst: "First",
  PagingLast: "Last",
  PagingNext: "Next",
  PagingPrevious: "Previous",
  Participant: "Participant",
  Participant_Add_ContextHelp_Title: "-",
  Participant_Add_Description: "-",
  Participant_Add_Submitting: "Creating participant …",
  Participant_Add_Success: "Participant has been added",
  Participant_CanSeeConfidential_Description: "Select whether the participant can see confidential documents",
  Participant_CanSeeConfidential_Title: "Show strictly confidential documents",
  Participant_Loading: "Loading participant …",
  Participant_Loading_EditForm: "Loading participant form …",
  Participant_NavBar_AddParticipant: "Add",
  Participant_NavBar_ToggleNav: "Show/hide navigation",
  Participant_Person_Title: "Person",
  Participant_Position_Description: "-",
  Participant_Position_Title: "Position",
  Participant_Remarks_Description: "Remarks on the participant",
  Participant_Remarks_Title: "Notes",
  Participant_Remove_Success: "Participant has been removed",
  Participant_Role_Description: "Please select Vorsitz (chair) or Protokoll (minutes) here. By default, the role Member is stored.",
  Participant_Role_Title: "Role",
  Participant_Status_Description: "Please select the status of the participant",
  Participant_Status_Title: "Status",
  Participant_User_Description: "Please select a member of the committee",
  Participant_User_Title: "Participant",
  ParticipantRole_Chair: "Chair",
  ParticipantRole_NoDataTemplate: "No role found",
  ParticipantRole_Placeholder: "Chose a role …",
  ParticipantRole_Protocol: "Protocol",
  Participants: "Participants",
  Participants_Description: "Contains the members of the committee",
  Participants_Loading: "Loading participants …",
  Participants_NavBar_View: "View",
  Participants_Title: "Participants",
  ParticipantsDetail_Empty: "Please select a participant",
  ParticipantsList_Empty: "No participants have been entered",
  ParticipantStatus_Deleted: "Deleted",
  ParticipantStatus_Excused: "Excused",
  ParticipantStatus_Present: "Present",
  ParticipantStatus_Unexcused: "Unexcused",
  ParticipantStatus_Unknown: "Unknown",
  Permission_Add_Error: "Permission could not be added: {0}",
  Permission_Add_Success: "Permission has been added",
  Permission_Remove_Error: "Permission could not be removed: {0}",
  Permission_Remove_Success: "Permission has been removed",
  Permissions: "Permissions",
  Personalisation: "Personalisation",
  PersonalSiteUrl: "Personal site url (OneDrive)",
  PersonnelNumber: "Personnel-Nr.",
  Phone: "Phone",
  Phonebook: "Phonebook",
  PhonebookLastSync: "Last synchronisation",
  Placeholder: "Placeholder",
  Properties: "Properties",
  PublishedDocuments: "Published documents",
  PublishedDocuments_Description: "Contains the published documents of a committee.",
  PublishingDocuments_Tooltip: "-",
  ReadMore_Less: "Show less …",
  ReadMore_More: "Show more …",
  RequestId: "Request ID",
  RichText_Link_Dialog_Title: "Edit link",
  RichText_Link_Invalid_URL: "Please enter a valid URL (https://, http://, mailto:)",
  RichText_Link_Remove: "Remove link",
  RichText_Link_Text_Label: "Display text",
  RichText_Link_URL_Label: "Objective",
  RichText_Paste_Cancel_Tooltip: "Cancel (undo paste)",
  RichText_Paste_KeepFormatting_Tooltip: "Keep Formatting",
  RichText_Paste_Options_Trigger_Tooltip: "Paste Options (Ctrl)",
  RichText_Paste_PlainText_Tooltip: "Paste as Plain Text",
  Richtext_Placeholder: "Enter text …",
  RichText_Tooltip_Background: "Background color",
  RichText_Tooltip_Blockquote: "Format as a block quote",
  RichText_Tooltip_Bold: "Bold (Ctrl+B)",
  RichText_Tooltip_Clean: "Clear formatting",
  RichText_Tooltip_Color: "Foreground color",
  RichText_Tooltip_Heading: "Heading",
  RichText_Tooltip_Indent_Minus1: "Decrease indentation (Shift+Tab)",
  RichText_Tooltip_Indent_Plus1: "Increase indentation (Tab)",
  RichText_Tooltip_Italic: "Italic (Ctrl+I)",
  RichText_Tooltip_Link: "Add a link",
  RichText_Tooltip_List_Bullet: "Add a list",
  RichText_Tooltip_List_Ordered: "Add a ordered list",
  RichText_Tooltip_Script_Sub: "Subscript",
  RichText_Tooltip_Script_Super: "Superscript",
  RichText_Tooltip_Size: "Font size",
  RichText_Tooltip_Source: "View HTML source",
  RichText_Tooltip_Strike: "Strikethrough",
  RichText_Tooltip_Underline: "Unterline (Ctrl+U)",
  Run: "Run",
  Runs: "Runs",
  Save: "Save",
  SelectAll: "Select all",
  Selected_Actions: "Selected actions",
  SendTo_Add_Error: "Connection could not be added: {0}",
  SendTo_Add_Success: "Connection has been added",
  SendTo_AddIncoming: "Add source comittee",
  SendTo_AddOutgoing: "Add target committee",
  SendTo_Incoming: "Incoming connections",
  SendTo_Outgoing: "Outgoing connections",
  SendTo_Remove_Error: "Connection could not be removed: {0}",
  SendTo_Remove_Success: "The connection has been deleted",
  SendtoPanel_Committee: "Committee",
  SendtoPanel_Description: "Select one or more target committees and their meetings and execute the action with Send.",
  SendtoPanel_Header: "Send to",
  SendtoPanel_Loading: "Loading committees …",
  SendtoPanel_Meeting: "Meeting",
  SendToPanel_Meeting_NoDataTemplate: "No meetings found",
  SendToPanel_Meeting_Placeholder: "Choose meeting …",
  SendtoPanel_Submit: "Send",
  SendtoPanel_Submitting: "Sending agenda items to the selected committees …",
  SendtoPanel_Success: "The agenda items have been sent successfully.",
  SendtoPanel_Title: "Help on Send to",
  SendToTargets: "Send-to boards",
  ShortName: "Short name",
  ShowDeleted: "Show deleted entries",
  ShowInactive: "Show inactive entries",
  ShowPermissions: "Show permissions",
  SignatureFirstName: "Firstname",
  SignatureFirstName_Undefined: "The setting 'Signature first name' is not defined in the board!",
  SignatureLastName: "Lastname",
  SignatureLastName_Undefined: "The 'Signature last name' setting is not defined in the board!",
  StandardAgendaItems: "Standard agenda items",
  StandardMeeting_Apply_Error: "Standard meeting could not be applied: {0}",
  StandardMeeting_Apply_Success: "Standard meeting was successfully applied.",
  StandardMeeting_Empty: "Empty",
  StandardMeeting_Old: "Old template (will be deleted soon!)",
  StandardMeetingsPanel_Description: "Select a standard meeting and apply the attributes of the meeting, agenda items and participants to the existing meeting. Only the meetings for which the \"Is standard\" attribute is set (see \"Meeting\" tab) are available.",
  StandardMeetingsPanel_Header: "Apply standard meeting",
  StandardMeetingsPanel_Preview_Loading: "Loading preview …",
  StandardMeetingsPanel_Submit: "Apply",
  StandardParticipants: "Standard participants",
  Statistics: "Statistics",
  Statistics_Loading: "Loading statistics …",
  Status: "Status",
  StatusCode_401_SubTitle: "You do not have access to the resource.",
  StatusCode_401_Title: "Access Denied",
  StatusCode_403_SubTitle: "You do not have permissions to access the resource.",
  StatusCode_403_Title: "Forbidden",
  StatusCode_404_SubTitle: "The resource was not found.",
  StatusCode_404_Title: "Not found",
  SuggestedAgendaItem_MeetingId_Title: "Meeting",
  SuggestedAgendaItems: "Submitted agenda items",
  SuggestedAgendaItems_Delete: "Delete",
  SuggestedAgendaItems_Delete_Success: "Selected items have been deleted.",
  SuggestedAgendaItems_Deleting: "Selected items are being deleted …",
  SuggestedAgendaItems_Description: "Contains the submitted items of the committee",
  SuggestedAgendaItems_Filter: "Filter",
  SuggestedAgendaItems_Loading: "Loading suggested agenda items …",
  SuggestedAgendaItems_Meeting: "Meeting",
  SuggestedAgendaItems_Meeting_Tooltip: "The meeting of the proposed agenda item. This is an informal note from the person who submitted the agenda item. The selected items are always added to the current meeting.",
  SuggestedAgendaItems_Move: "Add",
  SuggestedAgendaItems_Move_Success: "The selected items have been added to the current meeting.",
  SuggestedAgendaItems_Selection: "-",
  SuggestedAgendaItems_Selection_Tooltip: "Submitted items can be selected here. The actions Add and Delete can then be applied to the selected elements.",
  SuggestedAgendaItems_Submitting: "Selected items are added to the current meeting …",
  SuggestedAgendaItems_Title: "Title",
  SuggestedAgendaItems_Title_Tooltip: "Title of the suggested agenda item",
  SuggestedAgendaItemsPanel_Header: "Submitted agenda items",
  Table: "Table",
  Table_NoRows: "No records found.",
  Target: "Target",
  Task: "Task",
  Task_AgendaItem_Description: "-",
  Task_AgendaItem_Title: "Agenda item",
  Task_AssignedTo_Description: "-",
  Task_AssignedTo_Title: "Assigned to",
  Task_Description_Description: "-",
  Task_Description_Title: "Description",
  Task_DueDate_Description: "-",
  Task_DueDate_Title: "Due date",
  Task_Meeting_Description: "-",
  Task_Meeting_Title: "Meeting",
  Task_NavBar_AddTask: "Add",
  Task_NavBar_ToggleNav: "Show/hide navigation",
  Task_NotAssigned: "Not assigned",
  Task_Source_Description: "-",
  Task_Source_Title: "Source",
  Task_StartDate_Description: "-",
  Task_StartDate_Title: "Start date",
  Task_Status_Description: "-",
  Task_Status_Title: "Status",
  Task_Title: "Title",
  Task_Title_Title: "Title",
  Task_Title_Tooltip: "Title",
  Task_Validate_IsLonger_Title: "The Title field must not be longer than 255 characters",
  TaskFilterToggle_Description: "The dashboard only shows the pending items that are assigned to the current user.",
  TaskFilterToggle_Title: "Only my tasks",
  TaskGrid_ItemId: "Id",
  TaskGrid_ItemId_Tooltip: "The item id of the task",
  TaskList_Empty: "No tasks have been entered",
  Tasks: "Tasks",
  Tasks_Add: "Add task",
  Tasks_Description: "Contains the tasks of the committee",
  Tasks_Loading: "Loading tasks …",
  Tasks_Loading_EditForm: "Loading tasks form …",
  TasksDetail_Empty: "Please select a task",
  TaskStatus_Archived: "archived",
  TaskStatus_Complete: "Closed",
  TaskStatus_Default: "Draft",
  TaskStatus_Deferred: "Deferred",
  TaskStatus_InProgress: "In progress",
  TaskStatus_NotStarted: "Not started",
  TaskStatus_WaitingOnSomeoneElse: "Waiting on someone else",
  TaskToggle_Description: "Displays the tasks for all meetings.",
  TaskToggle_Title: "Show tasks",
  Template_Remove_Error: "Template could not be removed: {0}",
  Template_Remove_Success: "Template has been removed successfully",
  Templates: "Templates",
  Templates_ValidFileNames: "Valid file names",
  TemplatesDescription: "The standard configuration of the application is installed with the application by the SiVe development team. Corrections to templates are thus automatically updated for all instances of session management.",
  TenantName_Help: "The board name is used in the document templates and in the user interface of the meeting administration. Common values are the full name of a board such as Board of Directors or Executive Board.",
  TimePicker_Hours: "Hours",
  TimePicker_Minutes: "Minutes",
  Title: "Title",
  Toast_Error: "Error",
  Toast_Success: "Success",
  Toast_Warning: "Warning",
  Total: "Total",
  Upload_Choose: "Select files …",
  Upload_ClearSelectedFiles: "Clear selected files",
  Upload_DefaultDropZoneNote: "…",
  Upload_DropFilesHere: "Drop files here to upload them …",
  Upload_DropZoneHint: "Drop files here to upload them …",
  Upload_DropZoneNote: "Only {0} files are allowed.",
  Upload_Files: "Files",
  Upload_HeaderStatusUploaded: "Done",
  Upload_HeaderStatusUploading: "Upload…",
  Upload_InvalidFileExtension: "File type not allowed.",
  Upload_InvalidFiles: "Invalid files. Please check the requirements for the file upload.",
  Upload_InvalidMaxFileSize: "File size too large",
  Upload_InvalidMinFileSize: "File size too small",
  Upload_SelectNoFilesTitle: "Press to select further files",
  Upload_SelectTitle: "Select files…",
  Upload_StatusFailed: "Files could not be uploaded.",
  Upload_StatusUploaded: "Files successfully uploaded.",
  Upload_StatusUploadFailed: "Files could not be uploaded.",
  Upload_StatusUploading: "En cours de chargement …",
  Upload_StatusWarning: "Warning",
  Upload_Total: "Total",
  Upload_UploadSelectedFiles: "Upload selected files",
  UploadFile: "File",
  Upn: "Principal name",
  User: "User",
  User_AnonymizedDisplayName: "Deleted User",
  User_Boards: "Boards",
  User_DisplayName: "Name",
  User_Email: "Email",
  User_Email_Description: "Please enter the e-mail address here.",
  User_Email_Title: "Email",
  User_FirstName: "Firstname",
  User_FirstName_Description: "Please state first name.",
  User_FirstName_Title: "Firstname",
  User_Initials: "Initials",
  User_Initials_Description: "Please enter the abbreviation of the person here",
  User_Initials_HelpText: `If you leave the field empty, the default will be applied.<br/>
First letter of first name, first letter of surname.`,
  User_Initials_Preview: "Preview",
  User_Initials_Title: "Initials",
  User_Language: "Language",
  User_LastName: "Lastname",
  User_LastName_Description: "Please state surname.",
  User_LastName_Title: "Lastname",
  User_LastSync: "Last synchronisation",
  User_OrganisationUnit: "Organisation unit",
  User_PersonalSiteUrl: "Personal site url (OneDrive)",
  User_PersonnelNumber: "Personnel-Nr.",
  User_Phone: "Phone",
  User_Status: "Status",
  User_Sync_Error: "User could not be synchronized: {0}",
  User_Sync_NotSupported: "Synchronization for this user is not supported",
  User_Sync_Success: "User has been synchronized",
  User_Unknown: "Unknown",
  User_Update_Error: "User could not be saved: {0}",
  User_Update_Success: "User has been saved",
  User_Upn: "Principal name",
  User_UserRoles: "Roles",
  UserMenu_MyDetails: "My profile",
  UserMenu_SignOut: "Sign out",
  UserPicker: "Pick user",
  UserPicker_NoDataTemplate: "No participant found",
  UserPicker_Placeholder: "Enter identifier …",
  UserPreferences_Description: "Configure your preferences for the display of session management here. If your role does not include the display of deleted elements, for example, the corresponding setting has no effect.",
  UserRole_Administrator: "Administrator",
  UserRole_Application: "Application",
  UserRole_BoardOwner: "Board owner",
  UserRole_Unknown: "Unknown",
  UserRole_User: "User",
  UserRoles: "Roles",
  Users: "Users",
  UserSettings: "Settings",
  UserStatus_Deleted: "Deleted",
  UserStatus_Enabled: "Active",
  UserStatus_Unknown: "Unknown",
  Validation_Board_CannotArchiveWithActiveMeetings: "The board cannot be archived because it still has active meetings.",
  Validation_Board_NameAlreadyUsed: "A board with this value already exists ({0}, {1})",
  Validation_Date_MustBeEarlierThan: "The value of field '{0}' must be earlier than the value of field '{1}'.",
  Validation_Date_YearAtLeast: "'{0}' (Year) must be greater than or equal to {1}.",
  Validation_Document_ContentBytesEmpty: "The uploaded file '{0}' has an invalid length of 0 bytes.",
  Validation_Document_FileNameEmpty: "The uploaded file must not have an empty name.",
  Validation_Document_IsProtected: "The uploaded file '{0}' was detected as encrypted, reason: {1}.",
  Validation_Field_ConcurrentDashes: "'{0}' must not contain several hyphens consecutively.",
  Validation_Field_EndsWithDashes: "'{0}' must not end with hyphens.",
  Validation_Field_InvalidCharacters: "'{0}' contains invalid characters ('{1}', position: {2}).",
  Validation_Field_LeadingOrTrailingWhitespace: "'{0}' must not contain any spaces at the beginning or end.",
  Validation_Field_MustBeGreaterThanZero: "'{0}' must have a value greater than 0, is {1}.",
  Validation_Field_MustBeSameAs: "'{0}' ({1}) must contain the same value as '{2}' ({3}).",
  Validation_Field_MustNotBeEmpty: "'{0}' must not be empty.",
  Validation_Field_NotInValidNames: "'{0}' does not contain any valid names.",
  Validation_Field_StartsWithDashes: "'{0}' must not start with hyphens.",
  Validation_Participant_AlreadyExists: "There is already a participant '{0}' in this meeting.",
  ValidationFailures: "Validation errors",
  View_AgendaItems_Details: "Details",
  View_AgendaItems_Overview: "Overview",
  View_AgendaItems_Protocol: "Protocol",
  View_Documents_Grid: "Overview",
  View_OneDriveSync_Overview: "OneDrive Sync",
  View_Participants_Details: "Details",
  View_Participants_Overview: "Overview",
  View_Tasks_Overview: "Overview",
  View_Views_Edit: "Edit",
  Visitor: "Visitor",
  WorkingDocument: "Arbeitsdokument",
  WorkingDocument_FileExtension: "File extension",
  WorkingDocument_FileName: "Filename",
  WorkingDocument_FileSize: "Size",
  WorkingDocument_StorageUrl: "Blob Url",
  WorkingDocument_UniqueId: "Unique id",
  WorkingDocuments: "Working documents",
  WorkingDocuments_Add_Button: "Upload document",
  WorkingDocuments_Description: "Contains the committee's working documents",
  WorkingDocuments_Tooltip: "Open the corresponding folder in the working documents.",
  Yes: "Yes",
};
